import { render, staticRenderFns } from "./UserEditTabInformation.vue?vue&type=template&id=56fc765a&"
import script from "./UserEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./UserEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports